
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Hyperhydrosis(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Hyperhydrosis"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Hyperhidrosis is <b>abnormally excessive sweating that's not </b>
                                    necessarily related to heat or exercise. You may sweat so much
                                    that it soaks through your clothes or drips off your hands. Besides
                                    disrupting normal daily activities, this type of heavy sweating can
                                    cause social anxiety and embarrassment.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Hyperhydrosis/1.png")} alt="Hyperhydrosis" />
                                    </div>
                                </div>
                                <br></br>

                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>Sweating disrupts your daily routine</p>
                                <p>Sweating causes emotional distress or social withdrawal</p>
                                <p>You suddenly begin to sweat more than usual</p>
                                <p>You experience night sweats for no apparent reason</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Hyperhidrosis">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Hyperhydrosis;